import React, { useMemo, useState, useEffect, useCallback } from "react";
import { Table } from "../../Components/Table/Table";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const SalaryDetails = () => {
  const [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const role = "superadmin"; // TEMP

  // ✅ Load from localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("salaryData")) || [];

    const formatted = stored.map((item, index) => ({
      ...item,
      sno: index + 1,
    }));

    setData(formatted);
  }, []);

  // ✅ Delete
const handleDelete = useCallback((id) => {
  const confirmDelete = window.confirm("Are you sure?");
  if (!confirmDelete) return;

  setData((prevData) => {
    const updated = prevData.filter((item) => item._id !== id);
    localStorage.setItem("salaryData", JSON.stringify(updated));
    return updated;
  });
}, []);

  // ✅ Columns
  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Employee Name", accessor: "employee" },
      { Header: "Credit Date", accessor: "creditDate" },
      { Header: "Credit Time", accessor: "creditTime" },
      { Header: "Amount", accessor: "amount" },
      { Header: "Company Bank", accessor: "creditBankname" },
      { Header: "Employee Bank", accessor: "debitBankname" },
      { Header: "Company A/C", accessor: "companyAccount" },
      { Header: "My A/C", accessor: "employeeAccount" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Actions",
        Cell: ({ row }) =>
          role === "superadmin" && (
            <div className="action-icons">
              <EditIcon
                style={{ cursor: "pointer", marginRight: "10px" }}
                onClick={() =>
                  navigate(`/create-salary-details/${row.original._id}`)
                }
              />
              <DeleteIcon
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => handleDelete(row.original._id)}
              />
            </div>
          ),
      },
    ],
   [handleDelete, navigate]
  );

  return (
    <div className="timesheet-container">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="timesheet-title">Salary Details</h2>

        {/* ✅ Add Button */}
        <button
          className="add-btn"
          onClick={() => navigate("/create-salary-details")}
        >
          + Add Salary
        </button>
      </div>

      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show
      />
    </div>
  );
};

export default SalaryDetails;